export const API_ROOT = '/api/plugins';
export const INSTANCE_API_ROOT = '/api/instance';
export const GCOM_API_ROOT = '/api/gnet';

// Used for prefixing the Redux actions
export const STATE_PREFIX = 'plugins';
